import React from 'react';
import Head from 'next/head';
import PrivacyPolicy from '@features/common/components/PrivacyPolicy';
import { useIntl } from 'react-intl';
import { GetServerSideProps } from 'next';
import { IGetServerSideProps } from 'model/global.model';

const PrivacyPolicyPage = ({ title }: IGetServerSideProps) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Head>
				<title>{formatMessage({ id: 'bcs-Title-PP' })}</title>
				<link rel='icon' href='/favicon.ico' />
				<meta name='theme-color' content='#ffffff' />
				<meta property='og:title' content={title} key='ogTitle' />
			</Head>
			<PrivacyPolicy />
		</>
	);
};

export const getServerSideProps: GetServerSideProps = async () => {
	return {
		props: {
			title: 'Политики за поверителност | Gamy.fun',
		},
	};
};

export default PrivacyPolicyPage;
